import { ItemData, ItemType } from "../IronmonMapUtils";

export const kantoItems: ItemData[] = [
  // Vermillion City
  {
    x: 7832,
    y: 4116,
    type: ItemType.Normal,
  },
  {
    x: 7884,
    y: 3831,
    type: ItemType.Hidden,
  },
  {
    x: 7786,
    y: 4057,
    type: ItemType.Hidden,
  },
  {
    x: 7689,
    y: 4214,
    type: ItemType.Hidden,
  },
  {
    x: 7704,
    y: 4202,
    type: ItemType.Hidden,
  },
  {
    x: 7737,
    y: 4202,
    type: ItemType.Hidden,
  },
  {
    x: 8074,
    y: 4096,
    type: ItemType.Normal,
  },
  {
    x: 7879,
    y: 4375,
    type: ItemType.Hidden,
  },

  // Route 6
  {
    x: 7353,
    y: 3520,
    type: ItemType.TM,
  },

  // Route 9
  {
    x: 8392,
    y: 1575,
    type: ItemType.Normal,
  },
  {
    x: 8712,
    y: 1404,
    type: ItemType.Normal,
  },
  {
    x: 9340,
    y: 1280,
    type: ItemType.TM,
  },
  {
    x: 9449,
    y: 1340,
    type: ItemType.Hidden,
  },
  {
    x: 9308,
    y: 1576,
    type: ItemType.Normal,
  },

  // Power Plant
  {
    x: 9386,
    y: 2036,
    type: ItemType.Hidden,
  },

  // Route 7
  {
    x: 6908,
    y: 2677,
    type: ItemType.Normal,
  },

  // Celadon City
  {
    x: 5812,
    y: 2714,
    type: ItemType.TM,
  },
  {
    x: 6370,
    y: 3279,
    type: ItemType.Hidden,
  },

  // Route 8
  {
    x: 8418,
    y: 3001,
    type: ItemType.TM,
  },

  // Route 10
  {
    x: 9369,
    y: 2406,
    type: ItemType.TM,
  },

  // Route 25
  {
    x: 8756,
    y: 68,
    type: ItemType.Normal,
  },
  {
    x: 7438,
    y: 968,
    type: ItemType.Hidden,
  },
  {
    x: 7908,
    y: 131,
    type: ItemType.Hidden,
  },

  // Rock Tunnel
  // 1F
  {
    x: 8800,
    y: 1912,
    type: ItemType.TM,
  },
  {
    x: 8528,
    y: 2009,
    type: ItemType.Normal,
  },
  {
    x: 9024,
    y: 2056,
    type: ItemType.Hidden,
  },
  {
    x: 8673,
    y: 1763,
    type: ItemType.Hidden,
  },

  // B1F
  {
    x: 8912,
    y: 2450,
    type: ItemType.Normal,
  },
  {
    x: 8944,
    y: 2598,
    type: ItemType.Normal,
  },
  {
    x: 8656,
    y: 2574,
    type: ItemType.Normal,
  },
  {
    x: 8800,
    y: 2221,
    type: ItemType.Normal,
  },
  {
    x: 8816,
    y: 2608,
    type: ItemType.Hidden,
  },
  {
    x: 9025,
    y: 2609,
    type: ItemType.Hidden,
  },

  // Cinnabar Island
  {
    x: 3312,
    y: 6676,
    type: ItemType.Hidden,
  },
  {
    x: 3362,
    y: 6867,
    type: ItemType.Hidden,
  },
  {
    x: 3137,
    y: 6559,
    type: ItemType.Hidden,
  },
  {
    x: 3377,
    y: 6734,
    type: ItemType.Normal,
  },

  // Fuchsia City
  {
    x: 6364,
    y: 5545,
    type: ItemType.Hidden,
  },

  // Pewter City
  {
    x: 3273,
    y: 1454,
    type: ItemType.Hidden,
  },
  {
    x: 3216,
    y: 1225,
    type: ItemType.Hidden,
  },
  {
    x: 3744,
    y: 1307,
    type: ItemType.Hidden,
  },
  {
    x: 3120,
    y: 1092,
    type: ItemType.Normal,
  },

  // Viridian City
  {
    x: 3504,
    y: 3350,
    type: ItemType.Hidden,
  },

  // Diglett's Cave
  {
    x: 6884,
    y: 3811,
    type: ItemType.Hidden,
  },

  // Mt. Moon
  {
    x: 4576,
    y: 878,
    type: ItemType.Hidden,
  },

  // Underground Path
  {
    x: 7766,
    y: 2017,
    type: ItemType.Hidden,
  },
  {
    x: 7732,
    y: 1823,
    type: ItemType.Hidden,
  },

  // Viridian City/Forest
  {
    x: 4270,
    y: 2471,
    type: ItemType.Hidden,
  },
  {
    x: 3982,
    y: 2443,
    type: ItemType.Hidden,
  },
  {
    x: 3646,
    y: 2659,
    type: ItemType.Hidden,
  },
  {
    x: 3663,
    y: 2248,
    type: ItemType.Hidden,
  },
  {
    x: 3883,
    y: 2175,
    type: ItemType.Hidden,
  },
  {
    x: 4224,
    y: 2258,
    type: ItemType.Hidden,
  },
  {
    x: 4254,
    y: 1820,
    type: ItemType.Hidden,
  },
  {
    x: 3786,
    y: 2305,
    type: ItemType.Normal,
  },
  {
    x: 4278,
    y: 2501,
    type: ItemType.TM,
  },
  {
    x: 4148,
    y: 2025,
    type: ItemType.Normal,
  },
  {
    x: 3837,
    y: 1796,
    type: ItemType.Normal,
  },

  // Route 3
  {
    x: 4184,
    y: 1470,
    type: ItemType.Hidden,
  },
  {
    x: 4104,
    y: 1549,
    type: ItemType.Hidden,
  },
  {
    x: 5144,
    y: 1251,
    type: ItemType.Hidden,
  },
  {
    x: 4696,
    y: 1482,
    type: ItemType.Normal,
  },

  // Route 4
  {
    x: 6293,
    y: 895,
    type: ItemType.Hidden,
  },
  {
    x: 6802,
    y: 1135,
    type: ItemType.Hidden,
  },
  {
    x: 6853,
    y: 881,
    type: ItemType.Normal,
  },

  // Route 11
  {
    x: 8672,
    y: 3609,
    type: ItemType.Hidden,
  },
  {
    x: 9019,
    y: 3607,
    type: ItemType.TM,
  },

  // Route 12
  {
    x: 9239,
    y: 3723,
    type: ItemType.Hidden,
  },

  // Route 13
  {
    x: 8778,
    y: 4919,
    type: ItemType.Hidden,
  },

  // Route 17/Cycling Road
  {
    x: 4782,
    y: 4621,
    type: ItemType.Hidden,
  },
  {
    x: 4722,
    y: 5181,
    type: ItemType.Hidden,
  },

  // Route 19
  {
    x: 6017,
    y: 6102,
    type: ItemType.Hidden,
  },
  {
    x: 6000,
    y: 6160,
    type: ItemType.Hidden,
  },
  {
    x: 5969,
    y: 6273,
    type: ItemType.Hidden,
  },
  {
    x: 5826,
    y: 6296,
    type: ItemType.Hidden,
  },
  {
    x: 6017,
    y: 6884,
    type: ItemType.TM,
  },
  {
    x: 6002,
    y: 6896,
    type: ItemType.Hidden,
  },

  // Route 20
  {
    x: 4833,
    y: 6852,
    type: ItemType.Hidden,
  },
  {
    x: 4364,
    y: 6566,
    type: ItemType.Hidden,
  },
  {
    x: 4160,
    y: 6760,
    type: ItemType.Hidden,
  },

  // Route 21
  {
    x: 3247,
    y: 5867,
    type: ItemType.Hidden,
  },
  {
    x: 3331,
    y: 5930,
    type: ItemType.Hidden,
  },
  {
    x: 3357,
    y: 5494,
    type: ItemType.Hidden,
  },

  // Seafoam Islands
  // 1F
  {
    x: 4386,
    y: 6290,
    type: ItemType.Hidden,
  },

  // B1F
  {
    x: 4023,
    y: 6076,
    type: ItemType.Hidden,
  },
  {
    x: 4184,
    y: 5966,
    type: ItemType.Normal,
  },
  {
    x: 4072,
    y: 5913,
    type: ItemType.Normal,
  },

  // B2F
  {
    x: 3999,
    y: 5741,
    type: ItemType.Normal,
  },
  {
    x: 4369,
    y: 5624,
    type: ItemType.Hidden,
  },
  {
    x: 3776,
    y: 5518,
    type: ItemType.Hidden,
  },

  // B3F
  {
    x: 4024,
    y: 5261,
    type: ItemType.Normal,
  },
  {
    x: 4024,
    y: 5134,
    type: ItemType.Normal,
  },
  {
    x: 3848,
    y: 5099,
    type: ItemType.Hidden,
  },
  {
    x: 4296,
    y: 5331,
    type: ItemType.Hidden,
  },

  // B4F
  {
    x: 4329,
    y: 4653,
    type: ItemType.TM,
  },
  {
    x: 4120,
    y: 4604,
    type: ItemType.Normal,
  },
  {
    x: 4088,
    y: 4822,
    type: ItemType.Hidden,
  },

  // Cerulean Cave
  // 1F
  {
    x: 7623,
    y: 729,
    type: ItemType.Hidden,
  },
  {
    x: 7047,
    y: 665,
    type: ItemType.Hidden,
  },
  {
    x: 6998,
    y: 744,
    type: ItemType.Normal,
  },
  {
    x: 7350,
    y: 414,
    type: ItemType.Normal,
  },
  {
    x: 6806,
    y: 436,
    type: ItemType.Normal,
  },
  {
    x: 6743,
    y: 715,
    type: ItemType.Hidden,
  },
  {
    x: 7046,
    y: 267,
    type: ItemType.Normal,
  },

  // 2F
  {
    x: 6508,
    y: 386,
    type: ItemType.TM,
  },
  {
    x: 6492,
    y: 667,
    type: ItemType.Hidden,
  },
  {
    x: 6461,
    y: 548,
    type: ItemType.Hidden,
  },
  {
    x: 6505,
    y: 476,
    type: ItemType.Hidden,
  },
  {
    x: 6330,
    y: 657,
    type: ItemType.Hidden,
  },
  {
    x: 6235,
    y: 584,
    type: ItemType.Normal,
  },
  {
    x: 6316,
    y: 459,
    type: ItemType.Hidden,
  },
  {
    x: 5707,
    y: 395,
    type: ItemType.Hidden,
  },
  {
    x: 5739,
    y: 485,
    type: ItemType.Normal,
  },
  {
    x: 5803,
    y: 571,
    type: ItemType.Normal,
  },

  // B1F
  {
    x: 4819,
    y: 371,
    type: ItemType.Hidden,
  },
  {
    x: 4675,
    y: 610,
    type: ItemType.Normal,
  },
  {
    x: 5043,
    y: 558,
    type: ItemType.Normal,
  },
  {
    x: 5015,
    y: 478,
    type: ItemType.Hidden,
  },
  {
    x: 5091,
    y: 298,
    type: ItemType.Normal,
  },
  {
    x: 5523,
    y: 323,
    type: ItemType.Normal,
  },
  {
    x: 5507,
    y: 719,
    type: ItemType.Normal,
  },
  {
    x: 5220,
    y: 371,
    type: ItemType.Hidden,
  },

  // Route 28
  {
    x: 1183,
    y: 3471,
    type: ItemType.Hidden,
  },
  {
    x: 436,
    y: 3471,
    type: ItemType.Hidden,
  },
  {
    x: 1041,
    y: 3502,
    type: ItemType.TM,
  },
  {
    x: 129,
    y: 3657,
    type: ItemType.Normal,
  },

  // Mt. Silver
  // 1F
  {
    x: 807,
    y: 3013,
    type: ItemType.Hidden,
  },
  {
    x: 247,
    y: 2919,
    type: ItemType.Hidden,
  },
  {
    x: 807,
    y: 2649,
    type: ItemType.Hidden,
  },
  {
    x: 950,
    y: 2607,
    type: ItemType.Normal,
  },
  {
    x: 1199,
    y: 2606,
    type: ItemType.Normal,
  },
  {
    x: 344,
    y: 2141,
    type: ItemType.Hidden,
  },
  {
    x: 88,
    y: 2141,
    type: ItemType.Hidden,
  },

  // 2F
  {
    x: 702,
    y: 2387,
    type: ItemType.Normal,
  },
  {
    x: 702,
    y: 2106,
    type: ItemType.Normal,
  },
  {
    x: 830,
    y: 2038,
    type: ItemType.Normal,
  },
  {
    x: 1022,
    y: 2140,
    type: ItemType.Normal,
  },
  {
    x: 462,
    y: 2162,
    type: ItemType.Hidden,
  },
  {
    x: 1038,
    y: 1953,
    type: ItemType.Hidden,
  },

  // Lower Mountainside
  {
    x: 1262,
    y: 3146,
    type: ItemType.TM,
  },
  {
    x: 1454,
    y: 3221,
    type: ItemType.Normal,
  },

  // Upper Mountainside
  {
    x: 1601,
    y: 2029,
    type: ItemType.Normal,
  },
  {
    x: 1265,
    y: 2009,
    type: ItemType.Normal,
  },
  {
    x: 1474,
    y: 1723,
    type: ItemType.Hidden,
  },
  {
    x: 1554,
    y: 2017,
    type: ItemType.Hidden,
  },
  {
    x: 1426,
    y: 2010,
    type: ItemType.Hidden,
  },

  // 3F
  {
    x: 686,
    y: 1541,
    type: ItemType.Hidden,
  },

  // Route 12
  {
    x: 9163,
    y: 4198,
    type: ItemType.Normal,
  },
  {
    x: 9183,
    y: 4438,
    type: ItemType.Normal,
  },

  // Route 2
  {
    x: 3501,
    y: 1558,
    type: ItemType.Normal,
  },
  {
    x: 3378,
    y: 2888,
    type: ItemType.Normal,
  },

  // Route 15
  {
    x: 6806,
    y: 5660,
    type: ItemType.Normal,
  },
  {
    x: 7228,
    y: 5835,
    type: ItemType.Normal,
  },

  // Mt. Moon Square
  {
    x: 5526,
    y: 796,
    type: ItemType.Hidden,
  },
];
